import { AnaliseProjeto } from "./AnaliseProjeto";

export default AnaliseProjeto;